
import React, { useEffect } from "react";
import { Button, Card, CardBody, Col, Row, Form } from "react-bootstrap";
import { useNavigate, useParams } from "react-router-dom";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { JobFormatService } from "./service";
import { ErrorToast, SuccessToast } from "../../shared/toasters/toasters";
import { useTranslation } from "react-i18next";
import FormErrorSummary from "../../shared/components/FormErrorSummary";

const schema = yup.object().shape({
  title: yup.string().required('formErrors.titleRequired'),
});

const JobFormatForm: React.FC = () => {
  const { t } = useTranslation();
  const { id } = useParams<{ id: string }>();
  const isEdit = Boolean(id);
  const navigate = useNavigate();

  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),
    defaultValues: {
      title: "",
    },
  });

  useEffect(() => {
    if (isEdit) {
      const fetchJobFormat = async () => {
        try {
          const response = await JobFormatService.getSingle(+id!);
          reset(response);
        } catch (error) {
          ErrorToast(error);
        }
      };

      fetchJobFormat();
    }
  }, [isEdit, id, reset]);

  const onSubmit = async (data: { title: string }) => {
    try {
      if (isEdit) {
        await JobFormatService.update(data, +id!);
        SuccessToast(t("jobFormat.successUpdate"));
      } else {
        await JobFormatService.create(data);
        SuccessToast(t("jobFormat.successCreate"));
      }
      navigate("/job-formats");
    } catch (error) {
      ErrorToast(error);
    }
  };

  return (
    <React.Fragment>
      <Row>
        <Col sm={12}>
          <Card>
            <CardBody>
              <Form onSubmit={handleSubmit(onSubmit)}>
                <FormErrorSummary errors={errors} />
                <Row>
                  <Col sm={12}>
                    <div className="mb-3">
                      <label className="form-label">{t("jobFormat.title")}</label>
                      <input
                        type="text"
                        className={`form-control ${
                          errors.title ? "is-invalid" : ""
                        }`}
                        {...register("title")}
                      />
                      {errors.title && (
                        <div className="invalid-feedback">
                          {t(errors.title.message as string)}
                        </div>
                      )}
                    </div>
                  </Col>
                  <Col sm={12}>
                    <Button type="submit" variant="primary">
                      {t(`jobFormat.${isEdit ? "update" : "create"}`)}
                    </Button>
                  </Col>
                </Row>
              </Form>
            </CardBody>
          </Card>
        </Col>
      </Row>
    </React.Fragment>
  );
};

export default JobFormatForm;